import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  subtitle, 
  backgroundImage = "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
}) => {

  return (
    <div className="relative pt-32 pb-32 overflow-hidden">
      
      {/* Blurred Background Image */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center scale-110"
          style={{ 
            backgroundImage: `url(${backgroundImage})`,
            filter: 'blur(8px)'
          }}
        />

        {/* Subtle dark overlay for readability */}
        <div className="absolute inset-0 bg-black/25" />

        {/* Soft fade into bottom (helps wave blend) */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-6 text-white drop-shadow-xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
            {subtitle}
          </p>
        )}
      </div>

      {/* Decorative bottom wave */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 120" 
          preserveAspectRatio="none"
          className="w-full h-[120px]"
        >
          <path 
            fill="currentColor"
            d="M0,60 C360,100 1080,20 1440,60 L1440,120 L0,120 Z"
            className="fill-background-light dark:fill-background-dark"
          />
        </svg>
      </div>

    </div>
  );
};

export default PageHeader;